import React from 'react';

/**
 * Generic multi-select list with checkbox, sticky header, optional select-all.
 * Props:
 * - items: array of objects
 * - getId(item): unique id
 * - renderLabel(item): string/element for main label
 * - selected: Set of ids
 * - onToggle(id)
 * - height: max height (e.g., '18rem')
 * - emptyMessage
 * - showSelectAll: boolean
 */
export function MultiSelectList({
  items = [],
  getId = (i) => i.id,
  renderLabel = (i) => i.label ?? i.name ?? i.id,
  selected = new Set(),
  onToggle = () => {},
  onToggleAll = () => {},
  allVisibleSelected = false,
  height = '18rem',
  emptyMessage = 'No items.',
  showSelectAll = true,
  headerLabel = 'Items'
}) {
  return (
    <div className="border rounded-md divide-y bg-white" style={{ maxHeight: height, overflow: 'auto' }}>
      <div className="flex items-center px-3 py-2 bg-neutral-50 sticky top-0 z-10 text-xs uppercase tracking-wide">
        {showSelectAll && (
          <input
            type="checkbox"
            className="mr-2"
            checked={!!allVisibleSelected}
            onChange={onToggleAll}
          />
        )}
        <span className="font-medium truncate">{headerLabel}</span>
      </div>
      {items.map(item => {
        const id = getId(item);
        const isChecked = selected.has(id);
        return (
          <button
            key={id}
            type="button"
            onClick={() => onToggle(id)}
            className={`flex items-center w-full px-3 py-2 text-left text-sm hover:bg-primary-50 focus:outline-none ${isChecked ? 'bg-primary-50/70' : ''}`}
          >
            {showSelectAll && (
              <input
                type="checkbox"
                checked={isChecked}
                onChange={() => onToggle(id)}
                onClick={e => e.stopPropagation()}
                className="mr-2"
              />
            )}
            <span className="truncate flex-1">{renderLabel(item)}</span>
          </button>
        );
      })}
      {!items.length && (
        <div className="px-3 py-6 text-center text-sm text-neutral-500">{emptyMessage}</div>
      )}
    </div>
  );
}

export default MultiSelectList;
